import { Trans } from '@lingui/macro'
import React, { FC, useState } from 'react'
import { Box } from 'front-end/src/components'
import { useTimeout } from '../../../../app/hooks/useTimeout'
import { brandColors } from 'shared/basicPalette'
import { fontSizes, radii } from 'front-end/src/components/chakraThemeExtension'

interface Props {
  messageCode: number | null | undefined
}

export const NotificationMessage: FC<Props> = ({ messageCode }) => {
  const [show, setShow] = useState(true)

  useTimeout(() => setShow(false), 5000)

  if (!messageCode) {
    return null
  }

  return show ? (
    <Box
      position="absolute"
      data-test="NotificationBox"
      bgColor={brandColors.yellow[400]}
      fontSize={fontSizes.ssm}
      borderRadius={radii.md}
      ml="-140px"
      p="5px 10px"
      cursor="pointer"
      onClick={() => setShow(false)}
    >
      {messageCode === 101 && (
        <Trans>
          This resource has been updated since your last visit. Your progress
          was updated.
        </Trans>
      )}
      {messageCode === 102 && (
        <Trans>
          This resource has had a major update since your last visit. Your
          progress was reset.
        </Trans>
      )}
      {messageCode === 103 && (
        <Trans>
          This resource has been shared with you. Your progress was updated.
        </Trans>
      )}
      {messageCode === 104 && (
        <Trans>
          A new assignment has been created and your progress was reset.
        </Trans>
      )}
    </Box>
  ) : null
}
